import { createStore } from 'vuex'
import axios from 'axios'
import { axiosSetting } from '../utils/axiosSetting'
import router from '../router'
import prefectures from '../../public/json/prefectures.json'
import hospitalClass from '../../public/json/hospital_class_option.json'
import designatedHospital from '../../public/json/designated_hospital_option.json'
import keywords from '../../public/json/keyword_option.json'
import memberType from '../../public/json/member_type_option.json'
import gender from '../../public/json/gender_option.json'
import university from '../../public/json/university_option.json'
import departments from '../../public/json/departments_option.json'
import programSubjects from '../../public/json/program_subjects_option.json'
import featureTag from '../../public/json/feature_tag_option.json'
import facility from '../../public/json/facility_option.json'
import { home } from '@/store/modules/home'
import { events } from '@/store/modules/events'

import { StoreState, ActionHistory } from '../types/StoreState'

departments.sort((a: any, b: any) => {
  return a.priority - b.priority
})

const axiosAppAction = axiosSetting('app', 'action')

const state: StoreState = {
  isInitialized: false,
  isLogin: false,
  isPasswordToken: false,
  isPasswordResetToken: false,
  userInfo: {},
  registerEvent: {},
  visibleLimitedModal: false,
  limitedModalLoginQuery: '',
  visibleSearchModal: false,
  visibleScoringCriteriaModal: false,
  searchCoditionSaveFrg: true,
  isSearchSubmit: false,
  visibleLoading: false,
  currentScrollY: 0,
  systemError: {
    show: false,
    type: 'page'
  },
  master: {
    prefectures,
    hospitalClass,
    designatedHospital,
    keywords,
    memberType,
    gender,
    university,
    departments,
    programSubjects,
    featureTag,
    facility
  },
  eventParticipatingHospitals: [],
  cbtQuestions: []
}

export default createStore({
  state,

  mutations: {
    setUserInfo(state, value) {
      state.isLogin = true
      state.userInfo = value
    },

    setRegisterEvent(state, value) {
      state.registerEvent = value
    },

    setPasswordToken(state, payload) {
      state.isPasswordToken = payload
    },

    setPasswordResetToken(state, payload) {
      state.isPasswordResetToken = payload
    },

    resetUserInfo(state) {
      document.cookie = 'logout=2; path=/; max-age=600'
      state.isLogin = false
    },

    showLoading(state) {
      state.visibleLoading = true
    },

    closeLoading(state) {
      if (state.isInitialized) {
        state.visibleLoading = false
      } else {
        state.isInitialized = true

        const appLoad = document.getElementById('appLoad')
        if (appLoad) {
          appLoad.classList.add('hide')
          setTimeout(() => {
            appLoad.style.display = 'none'
          }, 500)
        }
      }
    },

    showSystemError(state, type) {
      state.systemError.show = true
      state.systemError.type = type
    },

    closeSystemError(state) {
      state.systemError.show = false
    },

    updateSearchSubmit(state, value) {
      state.isSearchSubmit = value
    },

    setSearchCoditionSaveFrg(state, flg) {
      state.searchCoditionSaveFrg = flg ? true : false
    },

    setEventParticipatingHospitals(state, value) {
      state.eventParticipatingHospitals = value
    },

    setCbtQuestions(state, value) {
      state.cbtQuestions = value
    },

    applyLogout(state) {
      state.visibleLoading = true
      document.cookie = 'logout=1; path=/; max-age=600'
      location.href = '/logout?home=true'
    },

    fixBody(state) {
      state.currentScrollY = window.scrollY
      const body = document.querySelector('body')
      if (!body) return
      body.style.position = 'fixed'
      body.style.width = '100%'
      body.style.top = -1 * state.currentScrollY + 'px'
    },

    unFixBody(state) {
      const body = document.querySelector('body')

      if (!body) return

      body.setAttribute('style', '')
      window.scrollTo(0, state.currentScrollY)
    }
  },

  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve) => {
        // モックでログイン状態を確認するときは下記3行をコメントアウトする
        const app = document.getElementById('app')
        const isLogin = app?.getAttribute('is-login') ? true : false
        if (!isLogin) return resolve('')

        axios
          .get('/api/v1/userInfo')
          .then((res) => {
            // ユーザーデータがなかったらログアウト(別の端末でログインした場合)
            if (!res.data) {
              return (location.href = '/logout')
            }

            commit('setUserInfo', res.data)
            return resolve('')
          })
          .catch(() => {
            location.href = '/logout'
          })
      })
    },

    showSearchModal({ state, commit }) {
      commit('fixBody')
      state.visibleSearchModal = true
    },

    closeSearchModal({ state, commit }) {
      commit('unFixBody')
      state.visibleSearchModal = false
    },

    checkLogin({ state, commit }) {
      if (!state.isLogin) {
        commit('fixBody')
        state.limitedModalLoginQuery = ''
        state.visibleLimitedModal = true
        return false
      }
      return true
    },

    moveLimitedPage({ state, commit }, value) {
      if (!state.isLogin) {
        commit('fixBody')
        state.visibleLimitedModal = true
        state.limitedModalLoginQuery = value
        return false
      }

      if (value.indexOf('http') === 0) {
        window.open(value)
        return
      }

      router.push(value)
    },

    closeLimitedModal({ state, commit }) {
      commit('unFixBody')
      state.visibleLimitedModal = false
    },

    showScoringCriteriaModal({ state, commit }) {
      commit('fixBody')
      state.visibleScoringCriteriaModal = true
    },

    closeScoringCriteriaModal({ state, commit }) {
      commit('unFixBody')
      state.visibleScoringCriteriaModal = false
    },

    addFavorite({ state, commit }, payload: { id: number; sId?: number }) {
      type Request = {
        hospital_id: number
        s_training_id?: number
      }
      type Response = {
        id: number
      }[]
      return new Promise((resolve, reject) => {
        if (!state.isLogin) {
          commit('fixBody')
          state.limitedModalLoginQuery = ''
          state.visibleLimitedModal = true
          return
        }

        const params: Request = {
          hospital_id: payload.id
        }
        if (payload.sId) params.s_training_id = payload.sId

        axiosAppAction
          .post<Response>('/api/v1/favorite/entry', params)
          .then((res) => {
            if (payload.sId) {
              state.userInfo.s_favorite_history.push({
                id: res.data[0].id,
                hospital_id: payload.id,
                s_training_id: payload.sId
              })
            } else {
              state.userInfo.favorite_history.push({
                id: res.data[0].id,
                hospital_id: payload.id
              })
            }
            return resolve('')
          })
          .catch(() => {
            commit('showSystemError', 'modal')
            return reject()
          })
      })
    },

    removeFavorite({ state, commit }, payload: { id: number; sId?: number }) {
      type Request = {
        hospital_id: number
        s_training_id?: number
      }
      type Response = ''
      return new Promise((resolve, reject) => {
        if (!state.isLogin) {
          commit('fixBody')
          state.limitedModalLoginQuery = ''
          state.visibleLimitedModal = true
          return
        }

        const params: Request = {
          hospital_id: payload.id
        }
        if (payload.sId) params.s_training_id = payload.sId

        axiosAppAction
          .post<Response>('/api/v1/favorite/cancel', params)
          .then(() => {
            if (payload.sId) {
              const index = state.userInfo.s_favorite_history.findIndex(
                (el: ActionHistory) => el.s_training_id == payload.sId
              )
              if (index > -1) state.userInfo.s_favorite_history.splice(index, 1)
            } else {
              const index = state.userInfo.favorite_history.findIndex(
                (el: ActionHistory) => el.hospital_id == payload.id
              )
              if (index > -1) state.userInfo.favorite_history.splice(index, 1)
            }
            return resolve('')
          })
          .catch(() => {
            commit('showSystemError', 'modal')
            return reject()
          })
      })
    },

    updateEventParticipatingHospitals({ commit }) {
      const getEventHospitals = axiosSetting('cms', 'action')
      getEventHospitals
        .get(`${process.env.VUE_APP_WPAPI_URL}dist/event_hospitals.json`)
        .then((res: any) => {
          if (res.data && Array.isArray(res.data.hospital_ids)) {
            commit('setEventParticipatingHospitals', res.data.hospital_ids)
          }
        })
    }
  },

  getters: {
    eventHospitalIds(state) {
      return state.eventParticipatingHospitals
    },

    isParticipateEvent: (state) => (hospitalId: string) => {
      if (!state.eventParticipatingHospitals) return false
      return state.eventParticipatingHospitals.includes(hospitalId)
    }
  },

  modules: {
    home,
    events
  }
})

export type RootState = typeof state
